module.exports = __webpack_public_path__ + "static/media/SCBrequest.9a68b6ab.svg";